import { Component } from '@angular/core';
import { LandingDesignBase } from '../landing-design-base';

// Diseño 2 de landing: cabecera, banner a todo el ancho y todas las secciones seguidas (sin pestañas),
// cada una con su grilla de cards.
@Component({
  selector: 'app-landing-design-2',
  templateUrl: './landing-design-2.component.html',
  styleUrls: ['./landing-design-2.component.scss'],
})
export class LandingDesign2Component extends LandingDesignBase {}
